<template>
  <div class="contact-form font-lato">
    <form 
      class="contact-form__contact-fields-wrapper" 
      @submit.prevent="onSend" novalidate
    >
      <div class="contact-form__contact-fields">
        <label for="contactFormName" class="text-secondary-color text-sm mb-2 block">Your Name</label>
        <div class="form-input">
          <input 
            type="text" 
            id="contactFormName" 
            name="name"
            placeholder="Your Name"
            v-model.trim="name"
            @input="$v.name.$touch()"
          >
          <span class="form-input__error" v-if="$v.name.$error && !$v.name.required">Field is required</span>
        </div>
      
        <div class="grid md:grid-cols-2 gap-4">
          <div class="form-input">
            <label for="contactFormEmail" class="text-secondary-color text-sm! mb-2 block">Your E-mail</label>
            <input 
              type="email" 
              id="contactFormEmail" 
              name="email"
              placeholder="Your E-mail"
              v-model.trim="email" 
              @input="$v.email.$touch()" 
            >
            <template v-if="$v.email.$error">
              <span class="form-input__error" v-if="!$v.email.required">Field is required</span>
              <span class="form-input__error" v-if="!$v.email.email">Email is not correct</span>
            </template>
          </div>
        
          <div class="form-input">
            <label for="contactFormPhone" class="text-secondary-color text-sm! mb-2 block">Your Phone</label>
            <input 
              type="text" 
              id="contactFormPhone" 
              name="phone"
              placeholder="Your Phone"
              v-model.trim="phone" 
              @input="$v.phone.$touch()"
            >
            <span class="form-input__error" v-if="$v.phone.$error && !$v.phone.required">Field is required</span>
          </div>
        </div>
          
        <div class="form-input">
          <label for="contactFormMessage" class="text-secondary-color text-sm! mb-2 block">Your Message</label>
          <textarea
            id="contactFormMessage"
            placeholder="Your Message"
            v-model.trim="message" 
            @input="$v.message.$touch()">
          </textarea>
          <template v-if="$v.message.$error">
            <span class="form-input__error" v-if="!$v.message.required">Field is required</span>
            <span class="form-input__error" v-if="!$v.message.minLength">
              Must have at least {{ $v.message.$params.minLength.min }} letters
            </span>
            <span class="form-input__error" v-if="!$v.message.maxLength">
              Must have at most {{ $v.message.$params.maxLength.max }} letters
            </span>
          </template>
        </div>
      </div>
      <div clas="form-input">
        <vue-recaptcha
          class="contact-form__recaptcha"
          ref="recaptcha"
          @verify="onVerify"
          @expired="onExpired"
          :sitekey="siteKey">
        </vue-recaptcha>
        <span class="form-input__error w-[304px] mx-auto!" v-if="$v.token.$error && !$v.token.required">reCAPTCHA is required</span>
      </div>
      <div class="contact-form__button-wrapper justify-end">
        <button 
          type="submit" 
          :disabled="submitting"
          class="contact-form__submit-button w-auto! rounded-[24px]!"
          :class="{
            'bg-primary-color': !getPrimaryColor,
            [`bg-[${getPrimaryColor}]`]: getPrimaryColor
          }"
        >
          <template v-if="submitting">Sending message...</template>
          <template v-else>Send message</template>
          <FontAwesomeIcon icon="long-arrow-alt-right" size="lg" class="ml-2" />
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import contactFormMixin from '@/shared/mixins/contactForm';

  export default {
    name: 'ContactForm',
    mixins: [
      contactFormMixin
    ],
    computed: {
      ...mapGetters('tour', ['getPrimaryColor'])
    }
  };
</script>

<style lang="scss">
  @import '../../../../styles/mixins.scss';
  @import '../../../../styles/variables.scss';

  .contact-form {
    .form-input {
      position: relative;
      margin-bottom: 15px;

      label {
        margin-left: 5px;
        margin-bottom: 5px;
        display: block;
        color: var(--contact-form-text-color);
        background-color: var(--contact-form-color);
        padding: 0 5px;
        transition: all 150ms linear;
      }

      textarea,
      input {
        border: 1px solid #D0D0D0;
        padding: 15px;
        font-size: 16px;
        font-weight: 400;
        width: 100%;
        height: 45px;
        box-sizing: border-box;
        background-color: #F3F5FB;
        color: var(--contact-form-input-color);
        border-radius: 24px;

        &:disabled {
          color: rgba(var(--contact-form-text-color), 0.6);
          background-color: var(--contact-form-label-color);
          pointer-events: none;
        }
      }

      ::placeholder {
        color: #858383;
      }

      textarea {
        resize: vertical;
        min-height: 70px;
        max-height: 500px;
      }

      :focus,
      :active,
      input:focus,
      input:active,
      textarea:focus,
      textarea:active {
        border-color: #444;
        outline: none;
      }

      &__error {
        margin-left: 0;
        margin-top: 7px;
        display: block;
        color: red;
        min-height: 20px;
        font-size: 14px;
        font-weight: 400;
      }
    }

    form div.form-input {
      margin-bottom: 25px;

      label {
        font-size: 15px;
        font-weight: 400;
        padding-left: 0;
        margin-left: 0;
        margin-bottom: 10px;
      }

      input,
      textarea {
        font-size: 14px;
        font-weight: 400;
        padding: 15px;
        color: #444;
      }

      textarea {
        min-height: 150px;
      }
    }

    &__recaptcha {
      margin-top: 50px;
    }

    &__button-wrapper {
      display: flex;
      margin-top: 40px;
      margin-bottom: 30px;
    }

    &__submit-button {
      // @include button($primary-color, #333);
      border-radius: 0;
      padding: 12px 24px;
      text-transform: uppercase;
      font-size: 13px;
      font-weight: 600;
      color: #fff;
      cursor: pointer;
    }
  }
</style>
